import { FormControl as ChakraFormControl, FormErrorMessage, FormHelperText, FormLabel } from '@chakra-ui/react';
import { FormControlOptions, SystemProps } from './primitives.types';

export interface FormControlProps extends SystemProps, FormControlOptions {
  label?: string;
  errorMessage?: string;
  helperText?: string;
  id?: string;
}

export function FormControl({
  children,
  label,
  errorMessage,
  helperText,
  ...systemProps
}: FormControlProps) {
  return (
    <ChakraFormControl {...systemProps}>
      {label && <FormLabel>{label}</FormLabel>}
      {children}
      {helperText && <FormHelperText mt="6px">{helperText}</FormHelperText>}
      {errorMessage && <FormErrorMessage>{errorMessage}</FormErrorMessage>}
    </ChakraFormControl>
  );
}